/**
 * Section "Documents inserés par l'Admin".
 * Extrait de DocumentSections.js (refactor P2 — Feb 2026).
 */
import React from 'react';
import { Button } from '../ui/button';
import { Upload, FileText, File, Eye, Download } from 'lucide-react';
import { downloadDocument, viewDocument } from '../../services/downloadService';
import { formatFileSize } from './helpers';

export default function AdminDocsSection({ items }) {
  if (!items?.length) return null;
  return (
    <div>
      <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2" data-testid="admin-docs-section-title">
        <Upload className="h-4 w-4 text-violet-500" />Documents inserés par l&apos;Admin ({items.length})
      </h4>
      <div className="space-y-2">
        {items.map((doc) => (
          <div key={doc.id} className="flex items-center justify-between p-3 bg-violet-50 rounded-lg border border-violet-200" data-testid={`admin-doc-${doc.id}`}>
            <div className="flex items-center gap-3">
              <div className="p-2 bg-white rounded-lg shadow-sm">
                {doc.mime_type?.includes('pdf') ? <FileText className="h-4 w-4 text-red-500" /> : <File className="h-4 w-4 text-violet-600" />}
              </div>
              <div>
                <p className="font-medium text-gray-900 text-sm">{doc.nom}</p>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  {doc.original_filename && <span>{doc.original_filename}</span>}
                  {doc.date_creation && <span>• {new Date(doc.date_creation).toLocaleDateString('fr-FR')}</span>}
                  {doc.file_size > 0 && <span>• {formatFileSize(doc.file_size)}</span>}
                </div>
                {doc.uploaded_by_name && (
                  <span className="text-xs text-violet-600">Inseré par {doc.uploaded_by_name}</span>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Button variant="outline" size="sm" className="border-violet-300 text-violet-700" data-testid={`view-admin-doc-${doc.id}`} onClick={() => viewDocument(doc)}>
                <Eye className="h-4 w-4 mr-1" />Voir
              </Button>
              <Button variant="outline" size="sm" className="border-violet-300 text-violet-700" data-testid={`download-admin-doc-${doc.id}`} onClick={() => downloadDocument(doc)}>
                <Download className="h-4 w-4 mr-1" />Télécharger
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
